export default {
  GET_ALL: `#graphql
  query getColors($search: String, $searchBy: String, $search1: String, $searchBy1: String, $limit: Int, $page: Int, $sort: String, $order: String, $init: Date, $final: Date) {
    getColors(search: $search, searchBy: $searchBy, search1: $search1, searchBy1: $searchBy1, limit: $limit, page: $page, sort: $sort, order: $order, init:  $init, final: $final)
    { 
      docs {
        color,
        order,
        activeBrands,
        activeColor,
        spanish,
        hexadecimal
      },
      totalDocs,
      limit,
      hasPrevPage,
      hasNextPage,
      page,
      totalPages,
      prevPage,
      nextPage,
      pagingCounter
    }            
  }`,

  GET_HISTORY: `#graphql
  query getColorsHistory($search: String, $searchBy: String, $search1: String, $searchBy1: String, $limit: Int, $page: Int, $sort: String, $order: String, $init: Date, $final: Date) {
    getColorsHistory(search: $search, searchBy: $searchBy, search1: $search1, searchBy1: $searchBy1, limit: $limit, page: $page, sort: $sort, order: $order, init:  $init, final: $final)
    { 
      docs {
        _id,
        version,
        color,
        spanish,
        hexadecimal,
        order,
        activeBrands,
        activeColor,
        transaction,
        createdAt,
        createdBy,
        updatedBy
      },
      totalDocs,
      limit,
      hasPrevPage,
      hasNextPage,
      page,
      totalPages,
      prevPage,
      nextPage,
      pagingCounter
    }            
  }`,

  NEW: `#graphql
  mutation NewColor($color: ColorInput!) {
    newColor(input: $color)
    {
      color,
      order,
      activeBrands,
      activeColor,
      spanish,
      hexadecimal
    }            
  }`,

  UPDATE: `#graphql
  mutation UpdateColor($color: String!, $colorUpdate: ColorUpdateInput!) {
    updateColor(color:$color, colorUpdate: $colorUpdate)
    {
      color
    }            
  }`,

  DELETE: `#graphql
  mutation DeleteColor($color: String!) {
    deleteColor(color:$color)
    {
      color
    }            
  }`
}



// WEBPACK FOOTER //
// ./src/graphql/color.js